import { HallOfFamePlayerTypes, MenuItemPlayerTypes } from '@app/types/hallOfFameTypes';

export const HallOfFamePlayerTypeToMenuItemPlayerTypeMap: Record<HallOfFamePlayerTypes, MenuItemPlayerTypes> = {
  [HallOfFamePlayerTypes.CHAMPIONS_LEAGUE]: MenuItemPlayerTypes.CHAMPIONS_LEAGUE,
  [HallOfFamePlayerTypes.GOALSCORER]: MenuItemPlayerTypes.GOALSCORER,
  [HallOfFamePlayerTypes.BALLON_D_OR]: MenuItemPlayerTypes.BALLON_D_OR,
  [HallOfFamePlayerTypes.CAPTAIN]: MenuItemPlayerTypes.CAPTAIN,
};
